import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VonalkodAdatlapDto extends IdentifiableDto {
	constructor() {
		super();
		this.feltoltoAdatlapNev = null;
		this.csomagNev = null;
		this.vonavizsgaVonalkodlkodVizsga = null;
		this.vonalkod = null;
		this.hibaXML = null;
	}

	setup(props) {
		super.setup(props);
		this.feltoltoAdatlapNev = props.feltoltoAdatlapNev;
		this.csomagNev = props.csomagNev;
		this.vizsgaVonalkod = props.vizsgaVonalkod;
		this.vonalkod = props.vonalkod;
		this.hibaXML = props.hibaXML;
		return this;
	}
}

export default VonalkodAdatlapDto;
